import { notification } from 'antd'
import { useEffect, createElement } from 'react'
import { ComponentController } from './component_controller'
import { CircleCheckMarkIcon } from './custom_icons'

type AntNotificationProps = {
  successTitle: string
  successBody: string
  errorTitle: string
  errorBody: string
}

const AntNotification = ({
  errorTitle,
  errorBody,
  successTitle,
  successBody,
}): AntNotificationProps => {
  useEffect(() => {
    if (errorTitle) {
      notification.error({
        message: errorTitle,
        description: errorBody,
        duration: 4,
      })
    } else if (successTitle) {
      notification.success({
        icon: createElement(CircleCheckMarkIcon, {
          className: 'ant-notification-icon',
        }),
        message: successTitle,
        description: successBody,
        duration: 4,
      })
    }
  }, [successTitle, successBody])

  return null
}

export class AntNotificationController extends ComponentController {
  get component() {
    return AntNotification
  }

  get initialProps() {
    const props = this.propsFromData

    return {
      errorTitle: props.errorTitle || '',
      errorBody: props.errorBody || '',
      successTitle: props.successTitle || '',
      successBody: props.successBody || '',
    }
  }
}
